import {DrawingDataItem, DrawingDataItemDrawResult, DrawingDataItemPoint} from "../drawingOnImageDrawingElement.model";

export class DrawingDataItemCircle extends DrawingDataItem {
    constructor() {
        super();
        this.typeValue = 'circle';
        this.properties = {
            location: undefined
        }
    }

    public getPointsToMove(): DrawingDataItemPoint[] {
        return [
            DrawingDataItemPoint.fromVisiblePoint(this.properties.location),
        ];
    }

    onMouseDbClick(canvasRelativeX: number, canvasRelativeY: number): DrawingDataItemDrawResult {
        this.properties.location = {
            x: canvasRelativeX,
            y: canvasRelativeY
        };
        return {
            stillDrawing: false,
            changed: true
        };
    }

    draw(ctx: CanvasRenderingContext2D) {
        const size = this.common.size;
        const location = this.properties.location;
        if (location) {
            ctx.beginPath();
            this.applyCommonToCanvas(ctx);
            ctx.arc(location.x, location.y, size / 2, 0, 2 * Math.PI);
            ctx.stroke();
        }
    }
}